export const ADVERT_TYPE_BTR = 'btr';
export const ADVERT_TYPE_HMO = 'hmo';
export const ADVERT_TYPE_SPARE_ROOM = 'spare_room';
